import { memo, useRef, useCallback, useEffect } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import SearchInput from './search_input';
import { THEME, COLOR, FONT, __WEB__ } from '../../constants/styles';
import { findCases } from '../../services/caseService';
import I18n from '../../I18n';

let _searchTimeoutId = null;

export default memo(function CaseSearch(props) {
  const doSearch = useCallback(
    (skip) => {
      const term = inputVal.current || '';
      if (term === '' && !props.loadOnInit) return;
      const query = {
        term,
        ...(props.filters || {}),
        ...(props.includeConsults ? { includeConsults: true } : null),
        skip: skip || 0,
        limit: props.limit || 30,
      };
      findCases(props.employerId, query).then((result) => {
        props.onResult?.(result, term);
      });
    },
    [props.employerId, props.onResult, props.includeConsults, props.loadOnInit, props.skip]
  );

  useEffect(
    function () {
      doSearch(props.skip);
    },
    [props.skip]
  );

  const inputVal = useRef('');
  const handleSubmit = useCallback(() => {
    if (!props.employerId) return;
    if (!inputVal.current) return;

    doSearch();
  }, [props.employerId, props.onResult]);
  const handleChangeText = useCallback((text) => {
    inputVal.current = text;
    if (text === '') {
      props.onResult?.({ rows: [], count: 0 });
      doSearch();
    } else if (text.length >= 3) {
      if (_searchTimeoutId) clearTimeout(_searchTimeoutId);
      _searchTimeoutId = setTimeout(() => {
        handleSubmit();
      }, 300);
    }
  });

  useEffect(handleSubmit, [props.toggleToRefreshSearch]);

  return (
    <SearchInput
      placeholder={props.searchLabel}
      handleChangeText={handleChangeText}
      onSubmit={null}
      containerStyle={styles.container}
    />
  );
});

const styles = StyleSheet.create({
  container: __WEB__
    ? {
        backgroundColor: COLOR.contrast,
        flex: 1,
      }
    : {
        flex: 1,
        marginHorizontal: 0,
        marginBottom: 5,
        borderRadius: 0,
        shadowOpacity: 0,
        shadowRadius: 0,
        shadowColor: COLOR.shadow,
        shadowOffset: { height: 0, width: 0 },
      },
});
